import { memo, useMemo } from 'react'

import useTokens from '@/hooks/use-tokens'

import { TopCoinsDataItem, ViewPropsCommon } from '../../types'
import View from './view'

type ContainerProps = {
  data: TopCoinsDataItem
  index: number
  columns: ViewPropsCommon['columns']
  onClickTokenItem: ViewPropsCommon['onClickTokenItem']
}

const Container = ({ data, index, columns, onClickTokenItem }: ContainerProps) => {
  const { tokenListMap, reUsdTokenInfo } = useTokens()

  const tokenA = useMemo(() => {
    return tokenListMap.get(data.tokenMint)
  }, [tokenListMap, data.tokenMint])

  const tokenB = useMemo(() => {
    if (data.tokenMint === reUsdTokenInfo.address) return
    return reUsdTokenInfo
  }, [data, reUsdTokenInfo])

  const computedProps = {
    index,
    data,
    tokenA,
    tokenB,
    columns,
    onClickTokenItem,
  }

  return <View {...computedProps} />
}

export default memo(Container)
